import { config } from 'env_def';
import { ErrMsgCodeMap } from '@/api/errMap';
import { parentWindowIframeTarget, systemEventAllType, } from '@/api/data/event';
import { api } from '@/api/api';
import { apis, environment, inWindow } from '@/config';
import { FixSizeQueue, ListStore, SequenceHelper } from '@/api/commonModel';
const env = typeof environment === 'string' ? environment : 'local';
const isDev = !['prod', 'prev'].includes(env);
class EventProcessingInfo {
    constructor(eventName) {
        const eventType = systemEventAllType[eventName];
        this.confirmedSeq = 0;
        this.lastEventSeq = 0;
        if (!eventType) {
            throw new Error('错误的系统事件类型');
        }
        if (eventType.persist && eventType.maxPersistNum && eventType.maxPersistNum > 1) {
            this.eventMemoryQueue = new FixSizeQueue(eventType.maxPersistNum);
        }
        if (eventType.eventType === 'workerMsg' || eventType.eventType === 'electronMsg' || eventType.eventType === 'iframeMsg') {
            this.waitingEvents = {};
        }
    }
}
class ObProcessingInfo {
    constructor(obId) {
        this.lastEventSeq = -1;
        this.registerTime = new Date().getTime();
        this.obId = obId;
    }
}
class EventApiImpl {
    constructor() {
        this.currentAccount = '';
        this.isEventListenerInited = false;
        this.name = apis.defaultEventApi;
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.dataTracker = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.loggerTracker = api.requireLogicalApi(apis.loggerApiImpl);
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
    }
    sendSysEvent(ev, notPersist, noPostInfo, toCertainOb) {
        var _a;
        const startTime = Date.now();
        if (!ev.noLog && ev.eventName === 'storeUserChangeEvent') {
        }
        if (ev.eventName === 'loginExpired' && inWindow()) {
            this.dataTracker.track('pc_auto_login_occurred', { bk: window.isBridgeWorker, path: window.location.pathname });
        }
        const eventType = this.checkEvent(ev);
        if (this.testEventExipred(eventType, ev, true)) {
            console.warn('[event] event expired !! ', ev);
            this.trackEvent('event_expired_when_sending', eventType, ev);
            return undefined;
        }
        ev.eventTime = ev.eventTime || new Date().getTime();
        const status = EventApiImpl.status[ev.eventName];
        if (!status) {
            return undefined;
        }
        ev.eventSeq = ev.eventSeq || status.lastEventSeq + 1;
        ev._account = ev._account || this.currentAccount || ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
        ev._fromPage = window.location.pathname;
        if (eventType.filter && !eventType.filter(ev)) {
            return undefined;
        }
        if (!ev.noLog) {
            console.log('[event] will send:' + ev.eventName, ev, status);
            this.trackEvent('event_send', eventType, ev, status);
        }
        const obMapElement = EventApiImpl.obMap[ev.eventName];
        if ((!eventType.persist || eventType.persist === 'none') && !obMapElement) {
            if (!isDev) {
                throw new Error('非持久化消息需要有消费者才可发送:' + ev.eventName);
            }
            else {
                return undefined;
            }
        }
        if (!notPersist) {
            this.persistEventData(eventType, ev);
        }
        if (eventType.acceptCount && eventType.acceptCount > 0) {
            if (status.lastEventSeq - status.confirmedSeq > eventType.acceptCount) {
                return undefined;
            }
        }
        const flag = (eventType.toAllWin || eventType.toType || ev.toType) && eventType.eventType === 'electronMsg';
        if (!flag || noPostInfo || (ev.eventSubItem && ev.eventSubItem > 0)) {
            if (toCertainOb) {
                if (!this.filterObEvent(toCertainOb, ev)) {
                    ev.isStick = true;
                    toCertainOb.func(ev);
                }
                return Promise.resolve('');
            }
            const eventHandled = this.handleEventConsuming({
                status,
                ev,
                obMapElement,
                eventType,
                noPostInfo: !!noPostInfo || !!ev.noPost,
            });
            if (Date.now() - startTime > 200) {
                console.warn(`[event]%cconsuming too long.${ev.eventName}.duration:${Date.now() - startTime}`, 'color:blue;background:yellow;font-size:14px', ev);
            }
            return eventHandled;
        }
        if (flag) {
            const eventHandled = this.sendEventToAll(status, ev, eventType);
            if (Date.now() - startTime > 200) {
                console.warn(`[event]%cconsuming too long.${ev.eventName}.duration:${Date.now() - startTime}`, 'color:blue;background:yellow;font-size:14px', ev);
            }
            return eventHandled;
        }
        throw new Error('发送事件的参数类型不合法');
    }
    trackEvent(evName, eventType, ev, status) {
        var _a, _b;
        if (!this.systemApi.isElectron()) {
            return;
        }
        if (Math.random() > (eventType.recordSample || 0.5)) {
            this.loggerTracker.track(evName, {
                event: JSON.stringify(ev).substr(0, eventType.recordLen || 2048),
                seq: ev.eventSeq,
                time: ev.eventTime,
                status: status
                    ? {
                        seq: status.lastEventSeq,
                        time: status.lastEventTime,
                        last: (_b = JSON.stringify(status.lastEvent || ((_a = status.eventMemoryQueue) === null || _a === void 0 ? void 0 : _a.toArray()))) === null || _b === void 0 ? void 0 : _b.substr(0, eventType.recordLen || 2048),
                    }
                    : undefined,
            });
        }
    }
    async sendEventToAll(status, ev, type) {
        const allInfos = await this.systemApi.getAllWindow();
        this.buildWebIdMap(allInfos);
        let infos = allInfos;
        if (ev.toType || type.toType) {
            const filterType = ev.toType || type.toType || [];
            infos = allInfos.filter(it => (filterType === null || filterType === void 0 ? void 0 : filterType.findIndex(tpit => it.type === tpit)) >= 0);
        }
        const selfWin = await this.systemApi.getCurrentWinInfo(true);
        const promises = [];
        const idSet = new Set();
        status.lastEventTime = ev.eventTime || 0;
        status.lastEventSeq = ev.eventSeq || 0;
        infos.forEach(win => {
            if (!idSet.has(win.webId)) {
                idSet.add(win.webId);
                if (win.id !== selfWin.id) {
                    if (!ev.noPost) {
                        const newEvent = Object.assign(Object.assign({}, ev), {
                            eventTarget: String(win.webId),
                            eventSubItem: ev.eventSeq,
                            eventSeq: undefined,
                            eventTime: undefined,
                            asInnerMsg: false,
                            noLog: true,
                        });
                        const items = this.sendSysEvent(newEvent);
                        if (items) {
                            promises.push(items);
                        }
                    }
                }
                else if (ev.asInnerMsg || type.asInnerMsg) {
                    const newEvent = Object.assign(Object.assign({}, ev), {
                        eventSubItem: ev.eventSeq,
                        eventSeq: undefined,
                        eventTime: undefined,
                        asInnerMsg: true,
                        noLog: true,
                    });
                    const items = this.sendSysEvent(newEvent, type.persist !== 'memory' && type.persist !== 'disk', true);
                    if (items) {
                        promises.push(items);
                    }
                }
            }
        });
        console.log('[event] send to all window got item:', promises.length);
        const toAllIds = infos.map(it => it.webId + ',' + it.id);
        this.loggerTracker.track('event_send_to_all', {
            evName: ev.eventName,
            evSeq: ev.eventSeq,
            evTime: ev.eventTime,
            toAll: toAllIds,
        });
        return promises.length > 0
            ? Promise.allSettled(promises)
                .then((rs) => {
                console.warn('[event] send all event to win got :', rs.map(it => it.status).join(' '));
                return '';
            })
                .catch(reason => {
                console.warn('[event] send to all window error ', reason);
                this.loggerTracker.track('event_send_to_all_error', {
                    evName: ev.eventName,
                    evSeq: ev.eventSeq,
                    evTime: ev.eventTime,
                    toAll: toAllIds,
                });
                return '发送全局事件出现错误';
            })
            : Promise.resolve('');
    }
    filterObEvent(ob, ev) {
        if (ob._account && ev._account && ob._account !== ev._account) {
            return true;
        }
        if (ob.nameFilter && ev.eventStrData) {
            if (typeof ob.nameFilter === 'string') {
                return ob.nameFilter === ev.eventStrData;
            }
            if (ob.nameFilter instanceof RegExp) {
                return ob.nameFilter.test(ev.eventStrData);
            }
        }
        return false;
    }
    handleEventConsuming(conf) {
        const { status, ev, obMapElement, eventType, noPostInfo } = conf;
        if (!noPostInfo && status.lastEventSeq && ev.eventSeq && ev.eventSeq > 0 && status.lastEventSeq === ev.eventSeq) {
            return Promise.resolve('');
        }
        status.lastEventTime = ev.eventTime || 0;
        status.lastEventSeq = ev.eventSeq || 0;
        const type = eventType.eventType;
        const asInnerMsg = ev.asInnerMsg !== undefined ? ev.asInnerMsg : !!eventType.asInnerMsg;
        console.time('[event] handleEventConsuming iterateObPromise' + ev.eventName);
        const iterateObPromise = (type === 'innerMsg' || !!noPostInfo || asInnerMsg) && obMapElement && obMapElement.total > 0
            ? obMapElement.iterate((ob) => {
                const element = status.eventActiveCount;
                status.eventActiveCount =
                    element ? (element + 1 > 90000000 ? 90000000 : element + 1) : 1;
                if (!this.filterObEvent(ob, ev)) {
                    console.log('[event] event processing: ', ev.eventName, ' -> ', ob.name);
                    ob.func(ev);
                }
            })
            : Promise.resolve('');
        return iterateObPromise
            .then(res => {
            console.timeEnd('[event] handleEventConsuming iterateObPromise' + ev.eventName);
            if (!ev.noLog) {
                console.log('[event] done system event dispatch with flag:' + noPostInfo, ev);
            }
            if ((type === 'workerMsg' || type === 'electronMsg' || type === 'iframeMsg') && !noPostInfo) {
                return this.postMessage(ev, !!ev.eventSubItem);
            }
            return res;
        })
            .catch(reason => {
            console.warn('[event] done  event handle got error:', ev, reason);
            return ErrMsgCodeMap['SEND.MSG.EXCEPTION'];
        });
    }
    persistEventData(eventType, ev) {
        if (eventType.persist && eventType.persist !== 'none') {
            this.persistEventToMemory(eventType, ev);
            if (eventType.persist === 'disk' && this.systemApi.isElectron()) {
                this.saveEventToLocal(ev);
            }
        }
    }
    checkEvent(ev) {
        if (!ev || !ev.eventName) {
            throw new Error('发送事件参数错误');
        }
        const eventType = systemEventAllType[ev.eventName];
        if (!eventType || !eventType.enable) {
            throw new Error('非法事件类型');
        }
        if (eventType.eventType === 'sysFeedback') {
            throw new Error('此类型事件无法通过外部接口发送');
        }
        if (!EventApiImpl.status[ev.eventName]) {
            throw new Error('此类型事件status未注册');
        }
        return eventType;
    }
    persistEventToMemory(eventType, ev) {
        if (eventType.maxPersistNum === 0)
            return;
        const size = eventType.maxPersistNum || 1;
        if (size === 1) {
            EventApiImpl.status[ev.eventName].lastEvent = ev;
            if (!ev.noLog) {
                console.log('[event] persist event to memory store:', ev);
            }
        }
        else {
            let queueElement = EventApiImpl.status[ev.eventName].eventMemoryQueue;
            if (!queueElement) {
                queueElement = new FixSizeQueue(size);
            }
            const num = queueElement.push(ev);
            if (!ev.noLog) {
                console.log('[event] persist event to memory queue:', num, ev);
            }
        }
    }
    confirmEvent(ev) {
        const eventType = this.checkEvent(ev);
        if (eventType.eventType === 'workerMsg' || eventType.eventType === 'electronMsg') {
            return;
        }
        const status = EventApiImpl.status[ev.eventName];
        const element = status.eventActiveCount;
        status.eventActiveCount =
            element !== undefined ? (element - 1 > 0 ? element - 1 : 0) : 0;
        status.confirmedSeq = ev.eventSeq || 0;
        if (eventType.acceptCount && eventType.acceptCount > 0) {
            if (status.lastEventSeq - status.confirmedSeq <= eventType.acceptCount) {
                this.dumpMessageFromQueue(ev.eventName, 1);
            }
        }
    }
    registerSysEventObserver(eventName, ob) {
        if (!inWindow()) {
            return 0;
        }
        if (typeof ob !== 'object' && typeof ob !== 'function') {
            throw new Error('添加监视者不合法');
        }
        if (inWindow() && environment !== 'prod') {
            console.log('[event] got event register:', eventName, ob);
        }
        const eventType = systemEventAllType[eventName];
        if (!eventType) {
            throw new Error('非法事件类型');
        }
        const re = this.addObObjToMap(EventApiImpl.obMap, eventName, ob);
        if (eventType.persist) {
            this.dumpMessageFromQueue(eventName, undefined, re.ob);
        }
        return re.ret;
    }
    getObserverByName(eventName, obName) {
        if (EventApiImpl.obNameMap.has(obName)) {
            const newVar = EventApiImpl.obNameMap.get(obName);
            const mapElement = EventApiImpl.obMap[eventName];
            return mapElement && newVar ? mapElement.getOb(newVar.obId) : undefined;
        }
        return undefined;
    }
    addObObjToMap(obMap, eventName, ob) {
        if (!obMap[eventName]) {
            obMap[eventName] = new ListStore();
        }
        ob.name = ob.name || 'no-name-' + (Math.floor(Math.random() * 1000) * 100000 + (Date.now() % 100000));
        ob.eventName = eventName;
        let ret;
        if (EventApiImpl.obNameMap.has(ob.name)) {
            const newVar = EventApiImpl.obNameMap.get(ob.name);
            if (newVar && newVar.obId) {
                ret = newVar.obId;
            }
        }
        if (ret === undefined) {
            ret = obMap[eventName].addOb(ob, ob.prepend);
            if (ob && !ob.name.startsWith('no-name-')) {
                EventApiImpl.obNameMap.set(ob.name, new ObProcessingInfo(ret));
            }
        }
        return { ob, ret };
    }
    unregisterSysEventObserver(eventName, id) {
        const obMapElement = EventApiImpl.obMap[eventName];
        if (!obMapElement) {
            return;
        }
        const eventType = systemEventAllType[eventName];
        if (!eventType) {
            return;
        }
        const ob = obMapElement === null || obMapElement === void 0 ? void 0 : obMapElement.removeOb(id);
        ob && !ob.name.startsWith('no-name-') && EventApiImpl.obNameMap.delete(ob.name);
        console.log('[event] remove observer of ' + eventName + ' :' + (ob === null || ob === void 0 ? void 0 : ob.name));
    }
    async postMessage(ev, noConfirm) {
        const eventType = this.checkEvent(ev);
        const status = EventApiImpl.status[ev.eventName];
        let finishSend = false;
        if (eventType.eventType === 'iframeMsg') {
            let target;
            if (ev.eventTarget) {
                target = EventApiImpl.iframeMap.get(ev.eventTarget);
            }
            if (!target) {
                const element = ev.iframeElementId ? EventApiImpl.getIframeWindowById(ev.iframeElementId) : EventApiImpl.iframeMap.get(ev.eventName) || window.parent;
                target = element;
            }
            if (target && target.postMessage) {
                target.postMessage(ev, EventApiImpl.host);
                if (!ev.noLog) {
                    console.log('[event] ***** post iframe message with flag ' + noConfirm + ':', ev);
                }
                finishSend = true;
                if (ev.eventTarget) {
                    EventApiImpl.iframeMap.delete(ev.eventTarget);
                }
            }
            else {
                return Promise.reject(new Error('SEND.MSG.EXCEPTION'));
            }
        }
        else if (eventType.eventType === 'workerMsg') {
            if (!eventType.handlerWorkerId) {
                return Promise.reject(new Error('SEND.MSG.EXCEPTION'));
            }
            const ob = EventApiImpl.webWorkMap.getOb(eventType.handlerWorkerId);
            if (ob) {
                ob.port.postMessage(ev);
                if (!ev.noLog) {
                    console.log('[event] ***** post worker message with flag ' + noConfirm + ':', ev);
                }
                finishSend = true;
            }
            else {
                return Promise.reject(new Error('SEND.MSG.EXCEPTION'));
            }
        }
        else if (eventType.eventType === 'electronMsg') {
            if (this.systemApi.isElectron() && window.electronLib) {
                const id = await this.buildEventSendId(ev);
                if (!id) {
                    return Promise.reject(new Error('no win id'));
                }
                window.electronLib.windowManage
                    .exchangeData({
                    id,
                    data: ev,
                })
                    .then();
                if (!ev.noLog) {
                    console.log('[event] ***** post electron message with flag ' + noConfirm + ':', ev);
                }
                finishSend = true;
            }
            else {
                return Promise.reject(new Error('not support by current environment'));
            }
        }
        else {
            return Promise.reject(new Error('not supported'));
        }
        if (finishSend && !noConfirm) {
            return new Promise((r, j) => {
                const tid = setTimeout(() => {
                    console.warn('[event] ***** failed confirm message for timeout :', ev);
                    j(new Error('事件返回确认超时，发送失败'));
                    this.saveEventToLocal(ev).then(() => {
                    });
                }, EventApiImpl.eventHandleTimeout);
                if (!status || !status.waitingEvents) {
                    j(new Error('内部错误，未生成必要的状态存储'));
                }
                if (ev.eventSeq) {
                    status.waitingEvents[ev.eventSeq] = (re) => {
                        var _a;
                        if (((_a = re.eventMsg) === null || _a === void 0 ? void 0 : _a.feedbackSeq) === ev.eventSeq) {
                            clearTimeout(tid);
                            delete status.waitingEvents[ev.eventSeq || 0];
                            if (!ev.noLog) {
                                console.log('[event] ***** finish confirm message:', ev, re);
                            }
                            r('');
                        }
                        else {
                            console.warn('[event] ***** failed confirm message for unknown :', ev, re);
                            j(new Error('未知错误，得到意外的返回事件'));
                        }
                    };
                }
                else {
                    j(new Error('未知错误，事件无序列号'));
                }
            });
        }
        return Promise.resolve('');
    }
    async buildEventSendId(ev) {
        let id;
        if (ev.eventTarget && /\d+/.test(ev.eventTarget)) {
            id = Number(ev.eventTarget);
        }
        else {
            const winInfo = await this.systemApi.getCurrentWinInfo(true);
            const winId = winInfo.parent;
            if (winId !== -1) {
                if (EventApiImpl.webIdMap.has(winId)) {
                    id = EventApiImpl.webIdMap.get(winId);
                }
                else {
                    const winInfos = await this.systemApi.getAllWindow();
                    this.buildWebIdMap(winInfos);
                    id = EventApiImpl.webIdMap.get(winId);
                }
            }
            ev.eventTarget = String(id);
        }
        console.log('[event] send event to win ' + id, ev);
        return id;
    }
    async saveEventToLocal(ev) {
        const eventType = this.checkEvent(ev);
        if (eventType.maxPersistNum === 0)
            return Promise.resolve();
        const size = eventType.maxPersistNum || 1;
        const eventKey = this.getStoredEventKey(ev);
        if (eventType.persistTTL && eventType.persistTTL <= 0) {
            return Promise.resolve();
        }
        if (size === 1) {
            await this.putEventToStore(eventKey, ev);
        }
        else {
            let data = [];
            const storeData = await this.getEventFromStore(eventKey);
            if (storeData && typeof storeData === 'string' && storeData.trim().length > 0) {
                data = JSON.parse(storeData);
            }
            data.push(ev);
            await this.putEventToStore(eventKey, data);
        }
        return Promise.resolve();
    }
    async putEventToStore(eventKey, ev) {
        const data = JSON.stringify(ev);
        try {
            if (this.systemApi.isElectron()) {
                await window.electronLib.storeManage.set('event', eventKey, data);
            }
            else {
                await this.storeApi.put(eventKey, data);
            }
        }
        catch (e) {
            console.warn('[event] save local', e);
        }
    }
    async getEventFromStore(eventKey) {
        try {
            if (this.systemApi.isElectron()) {
                return window.electronLib.storeManage.get('event', eventKey);
            }
            const dt = await this.storeApi.get(eventKey);
            if (dt && dt.suc && dt.data && dt.data.trim().length > 0) {
                return dt.data;
            }
        }
        catch (e) {
            console.warn('[event] get local', e);
        }
        return '';
    }
    setupIframe(eventType, eventName) {
        if (inWindow()) {
            const iframeId = eventType.iframeElementId && eventType.iframeElementId();
            const iframeWin = EventApiImpl.getIframeWindowById(iframeId);
            if (iframeWin) {
                EventApiImpl.iframeMap.set(eventName, iframeWin);
            }
        }
    }
    static getIframeWindowById(iframeId) {
        if (!iframeId) {
            return undefined;
        }
        if (iframeId === parentWindowIframeTarget) {
            return window.parent;
        }
        let iframeWin;
        if (iframeId) {
            const iframe = window.document.getElementById(iframeId);
            if (iframe && iframe.contentWindow) {
                iframeWin = iframe.contentWindow;
            }
        }
        return iframeWin;
    }
    setupWebWorker(param, name) {
        if (typeof window !== 'undefined' && typeof window.SharedWorker !== 'undefined') {
            if (param && param.handlerWorkScript) {
                const worker = new SharedWorker(param.handlerWorkScript, {
                    name: name || this.systemApi.md5(param.handlerWorkScript, true),
                    credentials: 'same-origin',
                });
                param.handlerWorkerId = EventApiImpl.webWorkMap.addOb(worker);
                worker.port.addEventListener('message', this.workerListener);
                worker.port.addEventListener('messageerror', this.workerErrorListener);
            }
        }
        return -1;
    }
    terminateWebWorker(id) {
        const ob = EventApiImpl.webWorkMap.getOb(id);
        if (ob) {
            ob.port.close();
        }
    }
    sendSimpleSysEvent(eventName) {
        return this.sendSysEvent({
            eventName,
            eventStrData: eventName,
        });
    }
    dumpMessageFromQueue(eventName, num, sendToCertainOb) {
        const eventType = systemEventAllType[eventName];
        if (eventType.persist === 'memory') {
            console.log('[event] handle persist event for ' + eventName, eventType);
            const size = eventType.maxPersistNum || 1;
            const status = EventApiImpl.status[eventName];
            if (!status) {
                throw new Error('not got status, why');
            }
            const el = status.lastEvent;
            if (size === 1 && el) {
                const expired = this.testEventExipred(eventType, el);
                if (!expired) {
                    this.sendSysEvent(el, true, true, sendToCertainOb);
                }
            }
            if (size > 1) {
                const element = status.eventMemoryQueue;
                num = num || (element === null || element === void 0 ? void 0 : element.size()) || 0;
                if (num < 1) {
                    return;
                }
                if (element) {
                    let el;
                    let index = 0;
                    const newArray = element.toArray();
                    while ((el = newArray.pop()) &&
                        index < num) {
                        index += 1;
                        const expired = this.testEventExipred(eventType, el);
                        if (!expired) {
                            this.sendSysEvent(el, true, true, sendToCertainOb);
                        }
                    }
                }
            }
        }
    }
    testEventExipred(eventType, el, testSending) {
        let expired;
        if (el.eventTime && eventType.persistTTL !== undefined) {
            expired = el.eventTime + (testSending ? (eventType.ttl || eventType.persistTTL) + eventType.persistTTL : eventType.persistTTL) <= Date.now();
        }
        return expired;
    }
    sendFeedback(data) {
        const eventType = systemEventAllType[data.eventName];
        console.log('[event] send feed back:' + data.eventName, data);
        if (eventType.eventType === 'electronMsg') {
            this.postMessage({
                eventMsg: {
                    feedbackSeq: data.eventSeq,
                },
                eventName: data.eventName,
                eventSeq: data.eventSeq,
                eventTarget: data.eventFrom,
            }, true).then();
        }
        else if (eventType.eventType === 'workerMsg' || eventType.eventType === 'iframeMsg') {
            this.postMessage({
                eventMsg: {
                    feedbackSeq: data.eventSeq,
                },
                eventName: data.eventName,
                eventSeq: data.eventSeq,
                eventTarget: data.eventFrom,
            }, true).then();
        }
    }
    resendSysEvent(data, noFeedback) {
        this.sendSysEvent(data, false, true) || Promise.resolve('');
        if (!noFeedback) {
            this.sendFeedback(data);
        }
    }
    workerListener(ev) {
        const data = ev.data;
        if (data && data.eventName && EventApiImpl.obMap[data.eventName]) {
            this.handleReceivedPostMsg(data);
        }
    }
    workerErrorListener(ev) {
        console.log('error', ev);
    }
    watchElectronMsg() {
        if (inWindow() && this.systemApi.isElectron() && window.electronLib) {
            window.electronLib.windowManage.addExchangeDataListener((res) => {
                console.warn('*******receive data from ipc:' + res.webId, res);
                const info = res.data;
                if (info) {
                    const data = info.data;
                    data.eventFrom = String(info.webId);
                    this.handleReceivedPostMsg(data);
                }
            });
        }
    }
    watchIframeMsg() {
        if (inWindow()) {
            window.addEventListener('message', ev => {
                const { origin } = ev;
                if (origin !== EventApiImpl.host) {
                    return;
                }
                const data = ev.data;
                if (data && data.eventName) {
                    data.eventFrom = 'ifr-' + EventApiImpl.seq.next();
                    EventApiImpl.iframeMap.set(data.eventFrom, ev.source);
                    this.handleReceivedPostMsg(data);
                }
            });
        }
    }
    handleReceivedPostMsg(data) {
        if (!data || !data.eventName) {
            return;
        }
        if (data.eventMsg && data.eventMsg.feedbackSeq) {
            const status = EventApiImpl.status[data.eventName];
            console.log('[event] *******handle feed back event:', data);
            if (!status || !status.waitingEvents) {
                throw new Error('内部错误，未生成必要的状态存储');
            }
            if (status.waitingEvents[data.eventMsg.feedbackSeq]) {
                status.waitingEvents[data.eventMsg.feedbackSeq](data);
            }
        }
        else {
            const eventType = systemEventAllType[data.eventName];
            if (eventType.eventType === 'electronMsg' || eventType.eventType === 'workerMsg' || eventType.eventType === 'iframeMsg') {
                this.resendSysEvent(data);
            }
        }
    }
    async loadEventFromLocal(eventName, eventType, noSend) {
        const size = eventType.maxPersistNum || 1;
        try {
            const winInfo = await this.systemApi.getCurrentWinInfo(true);
            if (!winInfo) {
                return;
            }
            const eventKey = this.getStoredEventKey({ eventName, eventTarget: String(winInfo.webId) });
            const storeData = await this.getEventFromStore(eventKey);
            if (storeData && typeof storeData === 'string' && storeData.trim().length > 0) {
                if (size === 1) {
                    const ev = JSON.parse(storeData);
                    this.handleLocalStoreEventItem({
                        ev,
                        noSend,
                        eventName,
                        eventKey,
                        eventType,
                    }).then();
                }
                else {
                    const evs = JSON.parse(storeData);
                    if (evs && evs.length > 0) {
                        evs.forEach(it => {
                            this.handleLocalStoreEventItem({
                                ev: it,
                                noSend,
                                eventName,
                                eventKey,
                                eventType,
                            }).then();
                        });
                    }
                }
            }
        }
        catch (e) {
            console.warn('[event] load from local error', e);
        }
    }
    getStoredEventKey(ev) {
        const eventType = this.checkEvent(ev);
        const { eventName } = ev;
        let id;
        if (eventType.eventType === 'electronMsg') {
            id = String(ev.eventTarget);
        }
        else if (eventType.eventType === 'workerMsg') {
            id = eventType.handlerWorkScript;
        }
        else if (eventType.eventType === 'iframeMsg') {
            id = (eventType.iframeElementId && eventType.iframeElementId()) || '';
        }
        return EventApiImpl.KEY_STORE_EVENT + (id ? '-' + id : '') + '-' + eventName;
    }
    async handleLocalStoreEventItem({ noSend, ev, eventName, eventKey, eventType, }) {
        await this.deleteEventFromLocal(eventKey);
        if (ev.eventTime && ((eventType.persistTTL && eventType.persistTTL > 0 && eventType.persistTTL + ev.eventTime > Date.now()) || eventType.persistTTL === undefined)) {
            if (!noSend) {
                this.resendSysEvent(ev, true);
            }
            else {
                const status = EventApiImpl.status[eventName];
                status.lastEvent = ev;
            }
        }
    }
    async deleteEventFromLocal(eventKey) {
        if (window.electronLib && this.systemApi.isElectron()) {
            await window.electronLib.storeManage.set('event', eventKey, '');
        }
        await this.storeApi.del(eventKey);
    }
    init() {
        console.log('[event] init called', this);
        if (this.isEventListenerInited)
            return this.name;
        systemEventAllType.error.filter = (ev) => {
            var _a;
            const now = new Date().getTime();
            const lastTime = EventApiImpl.status[ev.eventName].lastEventTime || 0;
            const eventActionCount = now - lastTime < 120000 ? EventApiImpl.status[ev.eventName].eventActiveCount || 0 : 0;
            EventApiImpl.status[ev.eventName].eventActiveCount = eventActionCount;
            return ((_a = ev.eventData) === null || _a === void 0 ? void 0 : _a.forcePopup) || ((!ev.auto || EventApiImpl.focused) && eventActionCount < 1 && (ev.eventTime || now) - lastTime > 3500);
        };
        console.log('[event] handle worker script init');
        const entries = Object.entries(systemEventAllType);
        const isInWeb = !this.systemApi.isElectron();
        entries.forEach(value => {
            console.log('[event] enabled event:' + value[0] + ' ' + value[1].eventType, value);
            const eventType = value[1];
            if (eventType.enable) {
                const eventName = value[0];
                EventApiImpl.status[eventName] = new EventProcessingInfo(eventName);
                if (eventType.eventType === 'electronMsg' || eventType.eventType === 'workerMsg') {
                    eventType.persist = eventType.persist || 'memory';
                }
                if (typeof eventType.toAllAccount !== 'boolean') {
                    eventType.toAllAccount = !!eventType.toAllAccount;
                }
                if (typeof window !== 'undefined' && (typeof window.SharedWorker !== 'undefined' || typeof window.Worker !== 'undefined')) {
                    if (eventType.eventType === 'workerMsg') {
                        this.setupWebWorker(eventType, eventName);
                    }
                    if (eventType.eventType === 'iframeMsg') {
                        this.setupIframe(eventType, eventName);
                    }
                }
                if (isInWeb && eventType.enableInWeb) {
                    eventType.toAllWin = false;
                    eventType.eventType = 'innerMsg';
                }
            }
        });
        this.watchElectronMsg();
        this.watchIframeMsg();
        this.isEventListenerInited = true;
        return this.name;
    }
    afterLoadFinish() {
        this.prepareWindow();
        return this.name;
    }
    prepareWindow() {
        if (inWindow() && this.systemApi.isElectron() && window.electronLib && this.systemApi.isMainWindow()) {
            setTimeout(async () => {
                const isLowMemoryMode = this.systemApi.getIsLowMemoryModeSync();
                const isLockApp = await this.systemApi.getIsLockApp();
                if (isLowMemoryMode || isLockApp) {
                    return;
                }
                const currentUser = this.systemApi.getCurrentUser();
                if (currentUser) {
                    this.currentAccount = currentUser.id;
                    window.electronLib.windowManage.prepareAllWindow().then();
                }
            }, 60000);
        }
    }
    afterInit() {
        if (inWindow() && this.systemApi.isElectron()) {
            this.loadAllEventUnhandledFromLocal();
        }
        return this.name;
    }
    beforeLogout() {
        return this.name;
    }
    afterLogin() {
        if (inWindow() && this.systemApi.isElectron()) {
            this.loadAllEventUnhandledFromLocal();
            this.prepareWindow();
        }
        return this.name;
    }
    loadAllEventUnhandledFromLocal() {
        const currentUser = this.storeApi.getCurrentUser();
        if (!currentUser) {
            return;
        }
        const entries = Object.entries(systemEventAllType);
        entries.forEach(value => {
            const eventType = value[1];
            if (eventType.enable && (eventType.eventType === 'electronMsg' || eventType.eventType === 'workerMsg')) {
                const eventName = value[0];
                this.loadEventFromLocal(eventName, eventType).then();
            }
        });
    }
    onBlur() {
        EventApiImpl.focused = false;
        return this.name;
    }
    onFocus() {
        this.systemApi.getActiveUserTrackParams().then(params => {
            this.dataTracker.track('pc_dailyActiveUser', Object.assign({ type: 'restartResult' }, (params || {})));
        });
        EventApiImpl.focused = true;
        return this.name;
    }
    buildWebIdMap(infos) {
        infos.forEach(it => {
            EventApiImpl.webIdMap.set(it.id, it.webId);
        });
    }
}
EventApiImpl.host = config('host');
EventApiImpl.debug = config('debug') === 'true';
EventApiImpl.lastErrKey = 'lastErrTime';
EventApiImpl.KEY_STORE_EVENT = 'persistEvent-';
EventApiImpl.eventHandleTimeout = 7500;
EventApiImpl.obMap = {};
EventApiImpl.obNameMap = new Map();
EventApiImpl.webWorkMap = new ListStore();
EventApiImpl.iframeMap = new Map();
EventApiImpl.seq = new SequenceHelper();
EventApiImpl.status = {};
EventApiImpl.focused = true;
EventApiImpl.webIdMap = new Map();
const eventApi = new EventApiImpl();
api.registerEventApi(eventApi);
export default eventApi;
